// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3ipBB","upload":"Small_upload__1rQ4W","imageWrap":"Small_imageWrap__2oPoV","removeBtn":"Small_removeBtn__dx7zg"};